import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

import { parseAddress } from "../../utils/Utils";

import "../../../styles/components/map/mapboxExtensions/Places.scss";

class Places extends Component {
  render() {
    return (
      <div id="places">
        {this.props.places.map((place, i) => {
          return (
            <div key={place._id}>
              <div
                className="place"
                onClick={e => this.props.query(e, place.address, this.props.country, this.props.keyTab)}
              >
                <p className="title">
                  <Translate
                    value={`accountDetails_${place.name}Label${this.props.isCompany ? "_b2b" : ""}`}
                  />
                </p>
                <p className="address">{parseAddress(place.address)}</p>
              </div>
              {i + 1 !== this.props.places.length && <hr className="splitter" />}
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  country: state.account.accountData.country,
  isCompany: state.account.isCompany,
});

export default connect(mapStateToProps, null)(Places);
